import axios from "axios";
import {
  loginFailure,
  loginStart,
  loginSuccess,
  registerFailure,
  registerStart,
  registerSuccess,
} from "./AuthActions";
import { API_URL } from "../../config/runtimeConfig";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const login = async (dispatch, user) => {
  dispatch(loginStart());
  try {
    const res = await axiosInstance.post("/delivery/auth/login", user);
    dispatch(loginSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(loginFailure(err.response.data.message));
    } else {
      dispatch(loginFailure());
    }
  }
};

export const register = async (dispatch, user) => {
  dispatch(registerStart());
  try {
    const res = await axiosInstance.post("/delivery/auth/register", user);
    dispatch(registerSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(registerFailure(err.response.data.message));
    } else {
      dispatch(registerFailure());
    }
  }
};
